<template>
	<div style="display:none;" />
	<!--<a-modal v-model="show" title="" centered :closable="false" :width="800" :mask-closable="false" :footer="null" :body-style="{'padding': 0}">
		<div class="d-flex">
			<div class="col-lg-5" :style="{'background': `url(${require('@/assets/img/bg/wpModal.jpg')}) no-repeat center center`}" />
			<div class="col-lg-7 px-5 py-4">
				<h2 class="mt-0 font-weight-bold">
					Vincula tu cuenta de WP
				</h2>
				<p class="font-size-lg text-black">
					Para poder sincronizar contenido entre ambas plataformas necesitamos que introduzcas tus credenciales de Wordpress
				</p>
				<p class="font-size-sm mb-3 text-black-50">
					AVISO: Estas credenciales se guardan en texto plano en tu dispositivo. No las introduzcas en un equipo publico.
				</p>
				<form @submit.prevent="wpAuth">
					<div class="form-group">
						<label>Usuario</label>
						<input v-model="wpuser" autofocus type="text" tabindex="1" class="form-control" required placeholder="ej: JhonDoe">
					</div>
					<div class="form-group mb-4">
						<div class="d-flex justify-content-between">
							<label>Contraseña</label>
						</div>
						<input v-model="wppassword" type="password" tabindex="2" class="form-control" placeholder="Introduce tu contraseña">
					</div>

					<button type="submit" class="btn btn-success btn-block">
						Guardar
					</button>
				</form>
			</div>
		</div>
	</a-modal>-->
</template>

<script>
export default {
	name: 'BackgroundProcess',
	data() {
		return {
			// wpuser: '',
			// wppassword: '',
			// show: false,
		};
	},
	computed: {
		pendingPosts() {
			return this.$store.getters['flags/pendingPosts'];
		},
		pendingCoupons() {
			return this.$store.getters['flags/pendingCoupons'];
		},
		settings() {
			return this.$store.getters.settings;
		},
		user() {
			return this.$store.getters.user;
		},
	},
	watch: {
		pendingPosts(newVal, oldVal) {
			this.playSoundOnNewItems(newVal, oldVal);
		},
		pendingCoupons(newVal, oldVal) {
			this.playSoundOnNewItems(newVal, oldVal);
		},
	},
	created() {
		this.checkPendingPosts();

		this.pendingPostsInterval = setInterval(() => {
			this.checkPendingPosts();
			this.$store.dispatch('deals/list', { reset: true, type: 'posts', warmOnly: true });
		}, 60000);
	},
	beforeUnmount() {
		clearInterval(this.pendingPostsInterval);
	},
	/* mounted() {
		const { user } = this.$store.getters;

		if (this.$sentry && user) {
			this.$sentry.configureScope((scope) => {
				scope.setUser({ username: user.username, id: user.id });
			});
		}
	},
	unmounted() {
		this.$hub.off('checkWpUser');
	}, */
	methods: {
		/* checkWpUser() {
			if (!this.$root.wpEnabled) this.show = true;
		}, */
		async checkPendingPosts() {
			const results = await this.$store.dispatch('deals/list', { reset: true, type: 'pendingPosts' });
			if (results.ok) this.$store.commit('CHANGE_FLAGS', { flag: 'pendingPosts', value: results.total });
		},
		async checkPendingCoupons() {
			const results = await this.$store.dispatch('coupons/list', { reset: true, type: 'pendingCoupons' });
			if (results.ok) this.$store.commit('CHANGE_FLAGS', { flag: 'pendingCoupons', value: results.total });
		},
		playSoundOnNewItems(oldVal, newVal) {
			if (newVal > 0 && oldVal === 0) {
				if (this.settings.audio) {
					try {
						// eslint-disable-next-line import/no-dynamic-require
						const audio = new Audio(require(`@/assets/sounds/${this.settings.audio}`));
						audio.play();
					} catch (e) {
						console.error(e);
					}
					// eslint-disable-next-line import/no-dynamic-require
				}
			}
		},
		/* async wpAuth() {
			const login = await this.$root.wordpress().login(this.wpuser, this.wppassword);

			if (login) {
				this.$store.commit('LOGINWP', { username: this.wpuser, password: this.wppassword });
				this.$message.success('Logueado correctamente');
				this.show = false;
			} else {
				this.$message.error('Usuario o contraseña erroneos');
			}
		}, */
	},
};
</script>

<style lang="scss" scoped>

</style>
